module.exports = __webpack_public_path__ + "img/tjx_18.93d96c98.png";